'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { Footer } from '@/app/_components/Footer';
import { BREAKPOINTS, DONATION_ROUTES, ROUTES } from '@/constants';
import { DonationSubHeader } from './_components/DonationLayout/DonationSubHeader';
import { InviteInflowController } from './_components/InviteInflowController/InviteInflowController';
import { DONATION_DESKTOP_HEADER_HEIGHT, DONATION_DESKTOP_STICKY_TOP } from './constants';

/**
 * footer를 제외하고 렌더링할 페이지 (정규표현식 패턴)
 */
const EXCLUDED_FOOTER_PATTERNS: RegExp[] = [/^\/donation\/my/, /^\/donation\/invite\/.+$/, /^\/donation\/callback\/.+\/.+$/, /^\/donation\/callback\/.+$/, /^\/donation\/event\/market/, /^\/donation\/gift-trial\/(review\/.+|apply)$/];

/**
 * footer를 제외하고 렌더링할 페이지
 */
const EXCLUDED_FOOTER_PATHNAMES: string[] = [DONATION_ROUTES.HOMETOWN_BUSINESS_ORDER.pathname, DONATION_ROUTES.DONATION_INVITE.pathname, DONATION_ROUTES.KB_CHECK_CARD.pathname, ROUTES.LOGIN.pathname, ROUTES.JOIN_COMMON.pathname, ROUTES.JOIN_COMPLETE.pathname, ROUTES.EASY_CERTIFICATION.pathname, ROUTES.EASY_CERTIFICATION_CALLBACK.pathname, ROUTES.LOCALFESTA.pathname, ROUTES.LOCALFESTA_APPLY.pathname, '/donation' + ROUTES.LOCALFESTA.pathname, '/donation' + ROUTES.LOCALFESTA_APPLY.pathname, DONATION_ROUTES.MARKET.pathname, '/event/kb-check-card'];

/**
 * 서브 헤더를 제외하고 렌더링할 페이지
 * - 풀블리드 이벤트 랜딩처럼 독립 비주얼이 필요한 페이지
 */
const EXCLUDED_SUB_HEADER_PATHNAMES: string[] = [DONATION_ROUTES.KB_CHECK_CARD.pathname,
// 검색 페이지는 자체 검색 헤더(fixed)를 가져 서브헤더와 겹친다 — 독립 비주얼로 둔다.
DONATION_ROUTES.SEARCH.pathname, '/event/kb-check-card'];

//* 체험단 신청·후기는 주문 화면처럼 서브헤더 없이 그린다
const EXCLUDED_SUB_HEADER_PATTERNS: RegExp[] = [/^\/donation\/gift-trial\/(review\/.+|apply)$/];
const Layout = t0 => {
  const $ = _c(19);
  const {
    children
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = !EXCLUDED_FOOTER_PATTERNS.some(pattern => pattern.test(pathname || "")) && !EXCLUDED_FOOTER_PATHNAMES.includes(pathname || "");
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const shouldShowFooter = t1;
  let t2;
  if ($[2] !== pathname) {
    t2 = !EXCLUDED_SUB_HEADER_PATHNAMES.includes(pathname || "") && !EXCLUDED_SUB_HEADER_PATTERNS.some(pattern_0 => pattern_0.test(pathname || ""));
    $[2] = pathname;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const shouldShowSubHeader = t2;
  const t3 = `@media ${BREAKPOINTS.DESKTOP} { html { scroll-padding-top: ${shouldShowSubHeader ? DONATION_DESKTOP_STICKY_TOP : DONATION_DESKTOP_HEADER_HEIGHT}px; } }`;
  let t4;
  if ($[4] !== t3) {
    t4 = <style>{t3}</style>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div data-donation-accent={true} hidden={true} />;
    t6 = <InviteInflowController />;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== shouldShowSubHeader) {
    t7 = shouldShowSubHeader ? <DonationSubHeader /> : null;
    $[8] = shouldShowSubHeader;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== children || $[11] !== t7) {
    t8 = <div className="flex min-h-dvh flex-1 flex-col">{t7}{children}</div>;
    $[10] = children;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== shouldShowFooter) {
    t9 = shouldShowFooter ? <Footer /> : null;
    $[13] = shouldShowFooter;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t4 || $[16] !== t8 || $[17] !== t9) {
    t10 = <>{t4}{t5}{t6}{t8}{t9}</>;
    $[15] = t4;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
export default Layout;